<div class="modal fade" id="privacyPolicyModal" tabindex="-1" aria-labelledby="privacyPolicyModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title fw-bold" id="privacyPolicyModalLabel">
          MedVisit Terms & Conditions, Privacy Policy & POPIA Notice
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">

        <!-- 1. Introduction -->
        <h5>1. Introduction</h5>

        <p>
          Welcome to MedVisit. MedVisit is a healthcare practice management
          platform designed to assist healthcare practitioners and their staff
          with appointment scheduling, patient filing, medical records
          management, communication and administrative tasks.
        </p>

        <p>
          By accessing or using the MedVisit platform, you acknowledge that
          you have read, understood and agreed to these Terms and Conditions,
          including the Privacy Policy and POPIA Notice contained herein.
        </p>

        <p>
          If you do not agree with these terms, please do not use the
          MedVisit platform.
        </p>

        <hr />

        <!-- 2. Business Information -->
        <h5>2. Business Information</h5>

        <p>
          MedVisit is currently operated as a sole proprietor business in
          South Africa.
        </p>

        <p>
          MedVisit is not currently registered as a private company
          (Pty) Ltd and is not registered for Value-Added Tax (VAT).
        </p>

        <p>
          All applicable MedVisit services and subscription charges are
          provided under the sole proprietor business operating MedVisit.
        </p>

        <p>
          MedVisit does not represent itself as a VAT-registered business,
          and no VAT is charged on MedVisit subscription fees while the
          business remains unregistered for VAT.
        </p>

        <p>
          MedVisit reserves the right to change its business structure or
          VAT registration status in the future. Any material changes will
          be communicated to customers where applicable.
        </p>

        <hr />

        <!-- 3. MedVisit Services -->
        <h5>3. MedVisit Services</h5>

        <p>
          MedVisit provides healthcare practice management tools that may
          include:
        </p>

        <ul>
          <li>Patient appointment scheduling and management</li>
          <li>Receptionist and staff account management</li>
          <li>Patient filing and medical history management</li>
          <li>Consultation notes and patient records</li>
          <li>Communication and team chat functionality</li>
          <li>Appointment reminders</li>
          <li>Administrative reporting</li>
          <li>Invoice generation for patients</li>
          <li>Other healthcare practice management functionality</li>
        </ul>

        <p>
          The availability of specific features may depend on the MedVisit
          subscription, platform version or service offering applicable to
          the customer.
        </p>

        <hr />

        <!-- 4. Appointment Booking and Invoices -->
        <h5>4. Appointment Booking and Invoice Generation</h5>

        <h6>4.1 Appointment Scheduling</h6>

        <p>
          The MedVisit appointment booking feature is intended to assist
          healthcare practitioners and their authorised staff in scheduling
          and managing patient appointments.
        </p>

        <p>
          Patients may be booked for consultations or other healthcare
          services offered by the relevant healthcare practice.
        </p>

        <h6>4.2 Booking Does Not Constitute Payment</h6>

        <p>
          <strong>
            MedVisit appointment booking is not a payment facility.
          </strong>
        </p>

        <p>
          The booking functionality is not intended to facilitate or process
          payment by a patient for an appointment, consultation or healthcare
          service.
        </p>

        <p>
          Creating or confirming an appointment through MedVisit does not
          mean that the patient has paid for the appointment or that payment
          has been received by the healthcare practitioner.
        </p>

        <h6>4.3 Invoice Generation</h6>

        <p>
          MedVisit may provide functionality that allows healthcare
          practitioners or authorised practice staff to generate an invoice
          for a patient in connection with a booked appointment or healthcare
          service.
        </p>

        <p>
          The invoice is an administrative document generated for the
          healthcare practice and patient. It may contain details such as:
        </p>

        <ul>
          <li>Patient name and relevant details</li>
          <li>Healthcare practitioner or practice information</li>
          <li>Appointment or consultation details</li>
          <li>Services provided or intended to be provided</li>
          <li>Amounts payable to the healthcare practice</li>
          <li>Invoice number and date</li>
        </ul>

        <p>
          <strong>
            Generating an invoice does not mean that MedVisit has collected
            payment from the patient.
          </strong>
        </p>

        <h6>4.4 Responsibility for Patient Payments</h6>

        <p>
          The healthcare practice or healthcare practitioner remains
          responsible for communicating payment requirements to patients,
          collecting payment, issuing appropriate receipts and managing any
          outstanding amounts.
        </p>

        <p>
          Unless expressly stated otherwise in a separate written agreement,
          MedVisit does not act as a payment processor, payment intermediary,
          healthcare provider or collection agent for the healthcare practice.
        </p>

        <p>
          MedVisit is not responsible for unpaid invoices, patient
          non-payment, disputes concerning consultation fees or the
          healthcare practice's billing arrangements.
        </p>

        <hr />

        <!-- 5. Subscription and Pricing -->
        <h5>5. Subscription, Trial and Pricing</h5>

        <h6>5.1 Trial Period</h6>

        <p>
          MedVisit may offer a one-month trial period to eligible healthcare
          practices.
        </p>

        <p>
          The trial allows customers to evaluate the platform before
          subscribing to the standard monthly service.
        </p>

        <p>
          MedVisit reserves the right to determine trial eligibility,
          applicable trial conditions and whether a trial may be extended
          or withdrawn.
        </p>

        <h6>5.2 Standard Pricing</h6>

        <p>
          After the applicable one-month trial period, the standard MedVisit
          subscription price is:
        </p>

        <p>
          <strong>R300 per month per clinic.</strong>
        </p>

        <p>
          This is the standard subscription price currently offered by
          MedVisit and may be changed in the future with reasonable notice
          to affected customers.
        </p>

        <p>
          MedVisit is not currently registered for VAT. Accordingly, VAT is
          not charged on the standard MedVisit subscription price while this
          status remains unchanged.
        </p>

        <h6>5.3 Subscription Payments</h6>

        <p>
          Customers are responsible for paying applicable MedVisit
          subscription fees in accordance with the payment instructions
          provided by MedVisit.
        </p>

        <p>
          Subscription fees relate to access to the MedVisit practice
          management platform. They are separate from any fees charged by
          healthcare practitioners to their patients.
        </p>

        <h6>5.4 Cancellation and Suspension</h6>

        <p>
          MedVisit may suspend or terminate access to the platform where
          subscription fees remain unpaid, the platform is misused, or
          these Terms and Conditions are materially breached.
        </p>

        <p>
          Customers may request cancellation of their subscription by
          contacting MedVisit through the available support channels.
        </p>

        <hr />

        <!-- 6. Healthcare Practice Responsibilities -->
        <h5>6. Healthcare Practice Responsibilities</h5>

        <p>
          Healthcare practitioners and practices using MedVisit are
          responsible for:
        </p>

        <ul>
          <li>
            Ensuring that patient information entered into the platform is
            accurate and up to date.
          </li>
          <li>
            Obtaining any necessary patient consent or other lawful
            authority to process personal information.
          </li>
          <li>
            Ensuring that only authorised staff members access patient
            information.
          </li>
          <li>
            Maintaining the confidentiality of login credentials.
          </li>
          <li>
            Managing patient appointments, cancellations and billing
            arrangements.
          </li>
          <li>
            Ensuring that patient invoices are accurate and appropriate.
          </li>
          <li>
            Complying with applicable healthcare, privacy and other legal
            requirements.
          </li>
        </ul>

        <p>
          MedVisit is a software platform and does not replace the
          professional judgement, clinical responsibilities or legal
          obligations of healthcare practitioners.
        </p>

        <hr />

        <!-- 7. Privacy Policy -->
        <h5>7. Privacy Policy and POPIA Notice</h5>

        <p>
          MedVisit is committed to protecting the privacy and personal
          information of healthcare practitioners, practice staff, patients
          and all users of the MedVisit platform.
        </p>

        <p>
          This Privacy Policy explains how MedVisit collects, processes,
          stores and protects personal information in accordance with the
          Protection of Personal Information Act (POPIA) of South Africa.
        </p>

        <hr />

        <!-- 8. Information We Collect -->
        <h5>8. Information We Collect</h5>

        <h6>User Information</h6>

        <ul>
          <li>First and last name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>User role</li>
          <li>Professional title</li>
          <li>Authentication details</li>
        </ul>

        <h6>Practice Information</h6>

        <ul>
          <li>Practice name</li>
          <li>Practice information</li>
          <li>Staff accounts</li>
          <li>Billing and subscription information</li>
        </ul>

        <h6>Patient Information</h6>

        <ul>
          <li>Patient demographics</li>
          <li>Medical history</li>
          <li>Consultation notes</li>
          <li>Diagnoses</li>
          <li>Prescriptions</li>
          <li>Appointments</li>
          <li>Uploaded medical documents</li>
          <li>Invoice and appointment-related information</li>
        </ul>

        <h6>Technical Information</h6>

        <ul>
          <li>IP addresses</li>
          <li>Browser and device information</li>
          <li>Audit logs</li>
          <li>Login history</li>
          <li>Platform usage information</li>
        </ul>

        <hr />

        <!-- 9. Why We Process Information -->
        <h5>9. Why We Process Information</h5>

        <p>
          Personal information may be processed for the following purposes:
        </p>

        <ul>
          <li>Manage appointments</li>
          <li>Maintain patient records</li>
          <li>Support communication between practices and patients</li>
          <li>Send appointment reminders</li>
          <li>Generate invoices and reports</li>
          <li>Manage subscriptions and customer accounts</li>
          <li>Improve platform functionality</li>
          <li>Meet legal obligations</li>
          <li>Prevent fraud and unauthorised access</li>
          <li>Maintain platform security and reliability</li>
        </ul>

        <hr />

        <!-- 10. Special Personal Information -->
        <h5>10. Special Personal Information</h5>

        <p>
          MedVisit may process health information, which is classified as
          Special Personal Information under POPIA.
        </p>

        <p>
          Health information may include medical history, diagnoses,
          prescriptions, consultation notes and other information relating
          to a patient's health.
        </p>

        <p>
          Such information should only be accessible to authorised
          healthcare professionals and authorised practice staff with a
          legitimate need to access it.
        </p>

        <p>
          Healthcare practices remain responsible for ensuring that their
          collection and use of patient health information is lawful and
          complies with applicable healthcare and privacy requirements.
        </p>

        <hr />

        <!-- 11. Sharing Information -->
        <h5>11. Sharing Information</h5>

        <p>
          MedVisit does not sell personal information.
        </p>

        <p>
          Personal information may be shared with or processed by:
        </p>

        <ul>
          <li>
            Healthcare professionals and authorised staff within the
            relevant practice.
          </li>
          <li>
            Cloud hosting and infrastructure providers.
          </li>
          <li>
            SMS and communication providers where required to deliver
            platform functionality.
          </li>
          <li>
            Service providers supporting the operation and maintenance of
            MedVisit.
          </li>
          <li>
            Authorities or regulators where disclosure is required or
            permitted by law.
          </li>
        </ul>

        <p>
          MedVisit seeks to ensure that service providers processing personal
          information on its behalf maintain appropriate confidentiality and
          security safeguards.
        </p>

        <hr />

        <!-- 12. Security -->
        <h5>12. Information Security</h5>

        <p>
          MedVisit uses reasonable technical and organisational safeguards
          intended to protect personal information against unauthorised
          access, loss, misuse, alteration or disclosure.
        </p>

        <p>
          These safeguards may include:
        </p>

        <ul>
          <li>HTTPS encryption</li>
          <li>Role-based access control</li>
          <li>Password hashing</li>
          <li>Audit logging</li>
          <li>Secure authentication</li>
          <li>Security monitoring</li>
          <li>Access restrictions</li>
        </ul>

        <p>
          While MedVisit takes reasonable steps to protect information, no
          internet-based system can be guaranteed to be completely secure.
        </p>

        <hr />

        <!-- 13. Data Retention -->
        <h5>13. Data Retention</h5>

        <p>
          Personal information is retained for as long as reasonably
          necessary to provide services, maintain business records, support
          legal obligations or resolve disputes.
        </p>

        <p>
          Retention periods may depend on the type of information, the
          purpose for which it was collected and applicable legal
          requirements.
        </p>

        <hr />

        <!-- 14. Your Rights -->
        <h5>14. Your Privacy Rights</h5>

        <p>
          Subject to applicable law, individuals may have the right to:
        </p>

        <ul>
          <li>Request access to their personal information.</li>
          <li>Request correction of inaccurate information.</li>
          <li>
            Request deletion of personal information where legally permitted.
          </li>
          <li>Object to certain processing of personal information.</li>
          <li>Withdraw consent where processing is based on consent.</li>
          <li>
            Lodge a complaint with the Information Regulator of South Africa.
          </li>
        </ul>

        <p>
          Requests may be directed to the MedVisit privacy contact below.
        </p>

        <hr />

        <!-- 15. Data Breaches -->
        <h5>15. Data Breaches and Security Incidents</h5>

        <p>
          If MedVisit becomes aware of a security incident that affects
          personal information, MedVisit will investigate the incident and
          take reasonable steps to contain and address it.
        </p>

        <p>
          Where required by POPIA or other applicable law, MedVisit will
          notify affected parties and the relevant authorities.
        </p>

        <hr />

        <!-- 16. Information Officer -->
        <h5>16. Privacy Contact and Information Officer</h5>

        <p>
          Privacy enquiries, personal information requests and POPIA-related
          concerns may be directed to:
        </p>

        <p>
          <strong>Email:</strong>
          admin@medvisit.co.za
        </p>

        <p>
          The appropriate MedVisit privacy contact will handle enquiries in
          accordance with applicable privacy requirements.
        </p>

        <hr />

        <!-- 17. Availability -->
        <h5>17. Platform Availability</h5>

        <p>
          MedVisit aims to provide a reliable service but does not guarantee
          uninterrupted or error-free availability of the platform.
        </p>

        <p>
          The platform may occasionally be unavailable due to maintenance,
          upgrades, technical issues, infrastructure failures or other
          circumstances beyond MedVisit's reasonable control.
        </p>

        <hr />

        <!-- 18. Changes -->
        <h5>18. Changes to These Terms and Policy</h5>

        <p>
          MedVisit may update these Terms and Conditions, Privacy Policy and
          POPIA Notice from time to time.
        </p>

        <p>
          The latest version will be made available within the MedVisit
          platform or through the relevant MedVisit website.
        </p>

        <p>
          Continued use of the platform after applicable updates may
          constitute acceptance of the revised terms.
        </p>

        <hr />

        <!-- 19. Contact -->
        <h5>19. Contact MedVisit</h5>

        <p>
          For general enquiries, support, billing questions or privacy
          concerns, please contact:
        </p>

        <p>
          <strong>Email:</strong>
          admin@medvisit.co.za
        </p>

      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>